var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWwIntro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7062 11.123C26.3583 12.4609 27.2691 13.5516 28.0898 14.4398C29.5739 16.0701 31.2605 17.5317 32.8907 18.9371C33.7677 19.6904 34.6447 20.4437 35.488 21.2308C36.0389 21.748 36.646 22.0066 37.2644 22.0066C37.8828 22.0066 38.5124 21.748 39.0971 21.2195C40.7161 19.7691 42.3239 18.33 43.9318 16.8684C45.607 15.3505 46.8438 14.0125 47.8445 12.6633C49.0475 11.033 49.5534 9.23409 49.3736 7.31147C49.1712 5.26518 48.1593 3.70235 46.439 2.78039C43.3471 1.13886 39.7042 1.46491 37.2307 3.51121C35.3193 1.92589 32.9245 1.38621 30.271 1.97087C28.3597 2.38687 26.9767 3.24137 26.066 4.56809C25.5601 5.29891 25.3464 6.08594 25.1778 6.71557L25.1328 9.08793L25.2003 9.53766C25.3015 10.0324 25.4364 10.5833 25.7062 11.123Z",
    fill: "#5458F7",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76113 44.4709H26.9992C26.9992 44.4709 25.8749 55.7143 22.5019 57.9629C19.1289 60.2116 15.7558 62.4603 11.2585 60.2116C6.76113 57.9629 4.51245 51.2169 4.51245 50.0926C4.51245 48.9682 6.76113 44.4709 6.76113 44.4709Z",
    fill: "#63C7C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4754 44.4709H47.2373C47.2373 44.4709 48.3616 55.7143 51.7347 57.9629C55.1077 60.2116 58.4807 62.4603 62.978 60.2116C67.4754 57.9629 69.7241 51.2169 69.7241 50.0926C69.7241 48.9682 67.4754 44.4709 67.4754 44.4709Z",
    fill: "#63C7C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7559 27.6058L6.76123 44.4709H26.9993L29.248 34.3518C29.248 34.3518 30.3723 30.9788 28.1237 29.8545C25.875 28.7301 18.0046 26.4814 18.0046 26.4814L15.7559 27.6058Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6374 27.6058L66.6321 44.4709H46.394L44.1453 34.3518C44.1453 34.3518 43.021 30.9788 45.2697 29.8545C47.5184 28.7301 55.3887 26.4814 55.3887 26.4814L57.6374 27.6058Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2248 59.998C68.2288 57.8168 70.9047 50.8121 67.869 45.1792L58.9193 28.5615C58.0873 27.0099 56.2433 26.3128 54.5906 26.9087L46.4728 29.8545C44.7976 30.4616 43.8307 32.2268 44.2242 33.9695L48.4292 52.4649C49.8234 58.6263 56.2996 62.1567 62.2248 59.998Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3887 69.33L60.4482 73.67",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4954 43.9424H67.2057",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2358 59.998L66.4184 71.5",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7194 59.998C5.71541 57.8168 3.03948 50.8121 6.0752 45.1792L15.0249 28.5615C15.8569 27.0099 17.7009 26.3128 19.3536 26.9087L27.4714 29.8545C29.1466 30.4616 30.1136 32.2268 29.72 33.9695L25.515 52.4649C24.1208 58.6263 17.6446 62.1567 11.7194 59.998Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55542 69.33L13.4959 73.67",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4601 43.9424H6.73853",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7082 59.998L7.52563 71.5",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwIntro);
export default __webpack_public_path__ + "static/media/ww-intro.81d41028.svg";
export { ForwardRef as ReactComponent };